// أداة تشغيل صوت الإشعارات
// تستخدم Web Audio API لتوليد نغمة بدون الحاجة لملف صوتي خارجي.
// ملاحظة: متصفحات iOS/Safari تمنع تشغيل الصوت قبل أول تفاعل من المستخدم،
// لذلك نقوم بـ "فك القفل" عند أول نقرة/لمسة.

let audioCtx = null;
let unlocked = false;

const SOUND_PREF_KEY = 'notificationSoundEnabled';

// قراءة تفضيل المستخدم لصوت الإشعارات (مفعّل افتراضياً)
export const isNotificationSoundEnabled = () => {
  try {
    return localStorage.getItem(SOUND_PREF_KEY) !== '0';
  } catch {
    return true;
  }
};

// حفظ تفضيل المستخدم لصوت الإشعارات
export const setNotificationSoundEnabled = (enabled) => {
  try {
    localStorage.setItem(SOUND_PREF_KEY, enabled ? '1' : '0');
  } catch {
    // تجاهل لو الـ localStorage غير متاح
  }
};

const getCtx = () => {
  if (audioCtx) return audioCtx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  audioCtx = new AC();
  return audioCtx;
};

const resumeIfNeeded = () => {
  const ctx = getCtx();
  if (ctx && ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  return ctx;
};

// تفعيل الصوت عند أول تفاعل من المستخدم (مطلوب على iOS تحديداً)
export const initNotificationSound = () => {
  if (typeof window === 'undefined' || unlocked) return;

  const handler = () => {
    resumeIfNeeded();
    unlocked = true;
    window.removeEventListener('click', handler);
    window.removeEventListener('touchend', handler);
    window.removeEventListener('keydown', handler);
  };

  window.addEventListener('click', handler, { once: false });
  window.addEventListener('touchend', handler, { once: false });
  window.addEventListener('keydown', handler, { once: false });
};

// تشغيل نغمة الإشعار (ding-dong قصيرة)
// options.force = true لتجاهل تفضيل الكتم (يُستخدم للمعاينة عند الضغط على الزر)
export const playNotificationSound = (options = {}) => {
  try {
    if (!options.force && !isNotificationSoundEnabled()) return;

    const ctx = resumeIfNeeded();
    if (!ctx) return;

    const now = ctx.currentTime;
    const notes = [
      { freq: 880, start: 0, dur: 0.18 },    // A5
      { freq: 1174.66, start: 0.15, dur: 0.28 }, // D6
    ];

    notes.forEach(({ freq, start, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.3, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + dur);
    });
  } catch (e) {
    // تجاهل أي خطأ في تشغيل الصوت حتى لا يؤثر على باقي التطبيق
  }
};
